import { render, staticRenderFns } from "./VehicletypesCrud.vue?vue&type=template&id=cf4c9326"
import script from "./VehicletypesCrud.vue?vue&type=script&lang=js"
export * from "./VehicletypesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports